import { ThemeColors } from '../../../'

export interface MangoAlertColors {
  Background: {
    Loading: ThemeColors
    Success: ThemeColors
    Error: ThemeColors
    Warning: ThemeColors
    Info: ThemeColors
  }
  BoxShadow: ThemeColors
  FontColor: ThemeColors
  Icon: ThemeColors
  CircularProgress: {
    TrackColor: ThemeColors
    ProgressColor: ThemeColors
  }
}

export const mangoAlertColors: MangoAlertColors = {
  Background: {
    Loading: {
      default: 'brand.solid',
    },
    Success: {
      default: 'green.solid',
    },
    Error: {
      default: 'red.solid',
    },
    Warning: {
      default: 'red.solid',
    },
    Info: {
      default: 'brand.solid',
    },
  },
  BoxShadow: {
    default: 'shadows.default',
  },
  FontColor: {
    default: 'brand.contrast',
  },
  Icon: {
    default: 'brand.contrast',
  },
  CircularProgress: {
    TrackColor: {
      default: 'bg.muted',
    },
    ProgressColor: {
      default: 'brand.contrast',
    },
  },
}
